<template>
    <form>
        <div class="row mt-3">
            <div class="col-lg-4">
                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__project_title_card_title"
                        )
                    }}
                </h4>
                <div class="form-group">
                    <textarea
                        class="form-control"
                        name="technical.titleOfProject"
                        v-model="GrantForm.title"
                        :error="getError('technical.titleOfProject')"
                        v-validate="'required'"
                        :data-vv-as="
                            $t(
                                'small_technical_grants_assessments.general_info__project_title_card_title'
                            )
                        "
                        :label="
                            $t(
                                'small_technical_grants_assessments.technical__1_title_of_project'
                            )
                        "
                        :placeholder="
                            $t(
                                'small_technical_grants_assessments.general_info__project_title_placeholder'
                            )
                        "
                    >
                    </textarea>
                </div>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__lead_applicant_name_card_title"
                        )
                    }}
                </h4>
                <div class="form-group">
                    <textarea
                        class="form-control"
                        name="technical.leadApplicantName"
                        v-model="
                            GrantForm.revisionModel.technical.leadApplicantName
                        "
                        :error="getError('technical.leadApplicantName')"
                        v-validate="'required'"
                        :placeholder="
                            $t(
                                'small_technical_grants_assessments.general_info__lead_applicant_name_placeholder'
                            )
                        "
                        :data-vv-as="
                            $t(
                                'small_technical_grants_assessments.general_info__lead_applicant_name_card_title'
                            )
                        "
                    >
                    </textarea>
                </div>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__lead_applicant_organisation_card_title"
                        )
                    }}
                </h4>
                <div class="form-group">
                    <h6>
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__lead_applicant_organisation_instructions"
                            )
                        }}
                    </h6>
                    <div class="mt-4"></div>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .organisationTypeGovernment
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_1"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .organisationTypeProtected
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_2"
                            )
                        }}
                    </base-checkbox>
                    <!-- new -->
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .organisationTransboundaryConservationAreas
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_3"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .organisationInvolvedProtectedConserved
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_4"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .organisationNetworkProtectedAreas
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__lead_applicant_organisation_checkbox_5"
                            )
                        }}
                    </base-checkbox>
                    <!-- new -->
                </div>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__co_applicant_name_card_title"
                        )
                    }}
                </h4>
                <div class="form-group">
                    <textarea
                        class="form-control"
                        name="technical.nameOfCoApplicants"
                        v-model="
                            GrantForm.revisionModel.technical.nameOfCoApplicants
                        "
                        :error="getError('technical.nameOfCoApplicants')"
                        v-validate="'required'"
                        :placeholder="
                            $t(
                                'small_technical_grants_assessments.general_info__co_applicant_name_placeholder'
                            )
                        "
                    >
                    </textarea>
                </div>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__co_applicant_organisation_card_title"
                        )
                    }}
                </h4>
                <div class="form-group">
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .coApplicantOrganisationTypeGovernment
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__co_applicant_organisation_checkbox_1"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .coApplicantOrganisationTypeProtected
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__co_applicant_organisation_checkbox_2"
                            )
                        }}
                    </base-checkbox>
                    <!-- new -->
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .coApplicantTransboundaryConservationAreas
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__co_applicant_organisation_checkbox_3"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .coApplicantInvolvedProtectedConserved
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__co_applicant_organisation_checkbox_4"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .coApplicantNetworkProtectedAreas
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__co_applicant_organisation_checkbox_5"
                            )
                        }}
                    </base-checkbox>
                    <!-- new -->
                </div>
            </div>

            <div class="col-lg-4">
                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__region_card_title"
                        )
                    }}
                </h4>
                <div class="form-group">
                    <label for="regionSelect">{{
                        $t(
                            "small_technical_grants_assessments.technical__1_region"
                        )
                    }}</label>
                    <select
                        class="form-control"
                        @change="setRegion"
                        name="technical.region"
                        id="regionSelect"
                        :error="getError('technical.region')"
                        v-validate="'required'"
                        :data-vv-as="
                            $t(
                                'small_technical_grants_assessments.technical__1_region'
                            )
                        "
                    >
                        <option value="" selected="selected"
                            >{{
                                $t(
                                    "small_technical_grants_assessments.general__please_select"
                                )
                            }}
                        </option>
                        <option
                            :value="region.regionId"
                            :selected="GrantForm.regionId === region.regionId"
                            v-for="region in regions"
                            :key="region.regionId"
                            >{{ region.code }} - {{ region.name }}
                        </option>
                    </select>
                    <label
                        v-if="getError('technical.region')"
                        class="error text-danger"
                        >{{ getError("technical.region") }}</label
                    >
                </div>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__acp_country_card_title"
                        )
                    }}
                </h4>
                <div
                    class="form-group"
                    :class="{ 'has-danger': getError('technical.acpCountry') }"
                >
                    <label for="countrySelect">{{
                        $t(
                            "small_technical_grants_assessments.technical__1_acp_country"
                        )
                    }}</label>
                    <multiselect
                        name="technical.acpCountry"
                        v-model="GrantForm.revisionModel.technical.acpCountry"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel="Clear"
                        v-validate="'required'"
                        :data-vv-as="
                            $t(
                                'small_technical_grants_assessments.technical__1_acp_country'
                            )
                        "
                        :tag-placeholder="
                            $t(
                                'small_technical_grants_assessments.general__please_select'
                            )
                        "
                        :placeholder="
                            $t(
                                'small_technical_grants_assessments.general__please_select'
                            )
                        "
                        label="name"
                        track-by="countryId"
                        :options="countriesByRegion"
                        :multiple="true"
                    ></multiselect>
                    <label
                        v-if="getError('technical.acpCountry')"
                        class="error text-danger"
                        >{{ getError("technical.acpCountry") }}</label
                    >
                </div>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__priority_area_targeted_card_title"
                        )
                    }}
                </h4>
                <h6>
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__priority_area_targeted_instructions"
                        )
                    }}
                </h6>
                <div class="form-group">
                    <!-- <h6>
            {{$t('small_technical_grants_assessments.general_info__lead_applicant_organisation_instructions')}}
          </h6> -->
                    <!-- <textarea
            class="form-control"
            name="technical.priorityAreaTargeted"
            v-model="GrantForm.revisionModel.technical.priorityAreaTargeted"
            :error="getError('technical.priorityAreaTargeted')"
            v-validate="'required'"
            :placeholder="$t('small_technical_grants_assessments.general_info__priority_area_targeted_placeholder')"
          >
          </textarea> -->
                    <!-- new -->
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .priorityAreaTargetedMarineProtected
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__priority_area_targeted_checkbox_1"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .priorityAreaTargetedMarineManaged
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__priority_area_targeted_checkbox_2"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .priorityAreaTargetedTerrestrialProtected
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__priority_area_targeted_checkbox_3"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .priorityAreaTargetedCommunityConserved
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__priority_area_targeted_checkbox_4"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .priorityAreaTargetedPrivatelyProtected
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__priority_area_targeted_checkbox_5"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .priorityAreaTargetedConservancy
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__priority_area_targeted_checkbox_6"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .priorityAreaTargetedKeyLandscape
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__priority_area_targeted_checkbox_7"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .priorityAreaTargetedKBAs
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__priority_area_targeted_checkbox_8"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .priorityAreaTargetedTransboundary
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__priority_area_targeted_checkbox_9"
                            )
                        }}
                    </base-checkbox>
                    <base-checkbox
                        name="checkbox"
                        v-model="
                            GrantForm.revisionModel.technical
                                .priorityAreaTargetedProtectedAreas
                        "
                    >
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__priority_area_targeted_checkbox_10"
                            )
                        }}
                    </base-checkbox>
                    <!-- new -->
                </div>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__pa_registration_number_card_title"
                        )
                    }}
                </h4>
                <h6>
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__pa_registration_number_instructions"
                        )
                    }}
                </h6>
                <div class="form-group">
                    <textarea
                        class="form-control"
                        name="technical.paRegistrationNumber"
                        v-model="
                            GrantForm.revisionModel.technical
                                .paRegistrationNumber
                        "
                        :error="getError('technical.paRegistrationNumber')"
                        v-validate="'required'"
                        :placeholder="
                            $t(
                                'small_technical_grants_assessments.general_info__pa_registration_number_placeholder'
                            )
                        "
                    >
                    </textarea>
                </div>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__pa_supervisory_authority_card_title"
                        )
                    }}
                </h4>
                <h6>
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__pa_supervisory_authority_instructions"
                        )
                    }}
                </h6>
                <div class="form-group">
                    <textarea
                        class="form-control"
                        name="technical.paSupervisoryAuthority"
                        v-model="
                            GrantForm.revisionModel.technical
                                .paSupervisoryAuthority
                        "
                        :error="getError('technical.paSupervisoryAuthority')"
                        v-validate="'required'"
                        :placeholder="
                            $t(
                                'small_technical_grants_assessments.general_info__pa_supervisory_authority_placeholder'
                            )
                        "
                    >
                    </textarea>
                </div>
            </div>

            <div class="col-lg-4">
                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__duration_card_title"
                        )
                    }}
                </h4>
                <div class="form-group">
                    <p style="color: red;" v-if="isValidDuration">
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__duration_validation_error"
                            )
                        }}
                    </p>
                    <!-- <textarea
            class="form-control"
            name="technical.duration"
            v-model="GrantForm.revisionModel.technical.duration"
            :error="getError('technical.duration')"
            @blur="handleValidDuration"
            v-validate="'required'"
            :data-vv-as="$t('small_technical_grants_assessments.technical__1_duration')"
            :label="$t('small_technical_grants_assessments.technical__1_duration')"
            :placeholder="$t('small_technical_grants_assessments.technical__1_duration')"
          >
          </textarea> -->
                    <input
                        class="form-control"
                        type="number"
                        name="technical.duration"
                        v-model="GrantForm.revisionModel.technical.duration"
                        :error="getError('technical.duration')"
                        @blur="handleValidDuration"
                        v-validate="'required'"
                        :data-vv-as="
                            $t(
                                'small_technical_grants_assessments.technical__1_duration'
                            )
                        "
                        :label="
                            $t(
                                'small_technical_grants_assessments.technical__1_duration'
                            )
                        "
                        :placeholder="
                            $t(
                                'small_technical_grants_assessments.technical__1_duration'
                            )
                        "
                        @keyup="setMinMaxDuration($event)"
                    />
                </div>

                <div class="row">
                    <p style="color: red;" v-if="isValidStartDate">
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__date_error"
                            )
                        }}
                    </p>

                    <div class="col-lg-6">
                        <base-input
                            name="technical.startDate"
                            v-model="
                                GrantForm.revisionModel.technical.startDate
                            "
                            :error="getError('technical.startDate')"
                            v-validate="'required'"
                            :data-vv-as="
                                $t(
                                    'small_technical_grants_assessments.technical__1_startdate'
                                )
                            "
                            :placeholder="
                                $t(
                                    'small_technical_grants_assessments.technical__1_startdate'
                                )
                            "
                        >
                            <label>{{
                                $t(
                                    "small_technical_grants_assessments.technical__1_startdate"
                                )
                            }}</label>
                            <el-date-picker
                                type="date"
                                v-model="startDate"
                                :placeholder="
                                    $t(
                                        'small_technical_grants_assessments.technical__1_startdate'
                                    )
                                "
                                @change="checkForValidDate"
                            >
                            </el-date-picker>
                        </base-input>
                    </div>
                    <div class="col-lg-6">
                        <base-input
                            name="technical.endDate"
                            v-model="GrantForm.revisionModel.technical.endDate"
                            :placeholder="
                                $t(
                                    'small_technical_grants_assessments.technical__1_enddate'
                                )
                            "
                            :error="getError('technical.endDate')"
                            v-validate="'required'"
                            :data-vv-as="
                                $t(
                                    'small_technical_grants_assessments.technical__1_enddate'
                                )
                            "
                        >
                            <label>{{
                                $t(
                                    "small_technical_grants_assessments.technical__1_enddate"
                                )
                            }}</label>
                            <el-date-picker
                                type="date"
                                v-model="endDate"
                                :placeholder="
                                    $t(
                                        'small_technical_grants_assessments.technical__1_enddate'
                                    )
                                "
                                @change="checkForValidDate"
                            >
                            </el-date-picker>
                        </base-input>
                    </div>
                </div>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__total_annual_budget_card_title"
                        )
                    }}
                </h4>
                <div class="form-group">
                    <currency-input
                        class="form-control"
                        name="technical.totalPaAnualBudget"
                        v-model="
                            GrantForm.revisionModel.technical.totalPaAnualBudget
                        "
                        :error="getError('technical.totalPaAnualBudget')"
                        currency="EUR"
                        locale="de"
                        v-validate="'required'"
                        :placeholder="
                            $t(
                                'small_technical_grants_assessments.general_info__total_annual_budget_placeholder'
                            )
                        "
                    />
                </div>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__total_funding_requested_card_title"
                        )
                    }}
                </h4>
                <div class="form-group">
                    <p style="color: red;" v-if="isValidFouds">
                        {{
                            $t(
                                "small_technical_grants_assessments.general_info__total_funding_budget_error"
                            )
                        }}
                    </p>
                    <currency-input
                        class="form-control"
                        name="technical.totalFundingRequested"
                        v-model="
                            GrantForm.revisionModel.technical
                                .totalFundingRequested
                        "
                        :error="getError('technical.totalFundingRequested')"
                        v-validate="'required'"
                        currency="EUR"
                        locale="de"
                        :placeholder="
                            $t(
                                'small_technical_grants_assessments.general_info__total_funding_budget_placeholder'
                            )
                        "
                        @blur="handleValidFounds"
                        @change="setMinMaxFounds($event)"
                    />
                </div>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.type_of__assessment_to_undertake_card_title"
                        )
                    }}
                </h4>
                <base-checkbox
                    name="checkbox"
                    v-model="
                        GrantForm.revisionModel.technical.typeOfAssessmentIMET
                    "
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_1"
                        )
                    }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="
                        GrantForm.revisionModel.technical.typeOfAssessmentMETT
                    "
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_2"
                        )
                    }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="
                        GrantForm.revisionModel.technical.typeOfAssessmentRAPPAM
                    "
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_3"
                        )
                    }}
                </base-checkbox>

                <base-checkbox
                    name="checkbox"
                    v-model="
                        GrantForm.revisionModel.technical.typeOfAssessmentIUCN
                    "
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_4"
                        )
                    }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="
                        GrantForm.revisionModel.technical.typeOfAssessmentEOH
                    "
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_5"
                        )
                    }}
                </base-checkbox>

                <base-checkbox
                    name="checkbox"
                    v-model="
                        GrantForm.revisionModel.technical.typeOfAssessmentSAPA
                    "
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_7"
                        )
                    }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="
                        GrantForm.revisionModel.technical.typeOfAssessmentSAGE
                    "
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_8"
                        )
                    }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="
                        GrantForm.revisionModel.technical.typeOfAssessmentGAPA
                    "
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_9"
                        )
                    }}
                </base-checkbox>

                <base-checkbox
                    name="checkbox"
                    v-model="
                        GrantForm.revisionModel.technical.equivalentAssessment
                    "
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_checkbox_6"
                        )
                    }}
                </base-checkbox>
                <label
                    style="font-size: 10px; margin-left: 25px; font-weight: 600"
                    >{{
                        $t(
                            "small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_instructions"
                        )
                    }}</label
                >

                <div
                    v-if="
                        GrantForm.revisionModel.technical.equivalentAssessment
                    "
                >
                    <br />
                    <input
                        class="form-control"
                        type="text"
                        name="technical.equivalentAssessment"
                        v-model="
                            GrantForm.revisionModel.technical
                                .customEquivalentAssessment
                        "
                        :error="getError('technical.equivalentAssessment')"
                        v-validate="'required'"
                        :placeholder="
                            $t(
                                'small_technical_grants_assessments.general_info__type_of_assessment_to_undertake_placeholder'
                            )
                        "
                    />
                    <br />
                </div>
                <!-- new -->
            </div>
        </div>
    </form>
</template>
<script>
import VueCurrencyInput from "vue-currency-input";

import { DatePicker } from "element-ui";
import Multiselect from "vue-multiselect";
import { GrantForm, RegionService } from "@/services";
import { BaseAlert } from "src/components";

export default {
    components: {
        [DatePicker.name]: DatePicker,
        Multiselect,
        BaseAlert,
        VueCurrencyInput
    },
    data() {
        return {
            isValidStartDate: false,
            isValidFouds: false,
            isValidDuration: false,
            GrantForm,
            startDate: "",
            endDate: "",
            moment: "",
            regions: [],
            options: [],
            value: [],
            downloadFiles: {
                en:
                    "/files/en/Application_template_BIOPAMA_medium_grants_2019_EN.docx",
                fr:
                    "/files/fr/Application_template_BIOPAMA_medium_grants_2019_FR.docx"
            }
        };
    },
    computed: {
        countriesByRegion() {
            let countries = [];
            let region = this.regions.filter(region => {
                return region.regionId === GrantForm.regionId;
            });
            if (
                region[0] !== undefined &&
                region[0].countries !== undefined &&
                region[0].countries.length
            ) {
                countries = region[0].countries;
            }
            return countries;
        }
    },
    async beforeMount() {
        this.moment = require("moment");

        let loader = this.$loading.show();
        let vm = this;
        RegionService.getApplicationRegionsWithCountries().then(function(
            response
        ) {
            vm.regions = response.data;

            loader.hide();
        });

        if (GrantForm.revisionModel.technical.startDate !== undefined) {
            this.startDate = GrantForm.revisionModel.technical.startDate;
        }

        if (GrantForm.revisionModel.technical.endDate !== undefined) {
            this.endDate = GrantForm.revisionModel.technical.endDate;
        }
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            return this.$validator.validateAll().then(res => {
                this.$emit("on-validated", res, this.model);
                return res;
            });
        },
        setRegion(event) {
            GrantForm.regionId = parseInt(event.target.value);
            GrantForm.revisionModel.technical.acpCountry = [];
        },
        handleValidDuration() {
            if (
                GrantForm.revisionModel.technical.duration >= 1 &&
                GrantForm.revisionModel.technical.duration <= 5
            ) {
                this.isValidDuration = false;
            } else {
                this.isValidDuration = true;
            }
        },
        setMinMaxDuration(event) {
            if (event.target.value < 1) {
                GrantForm.revisionModel.technical.duration = 1;
                this.isValidDuration = true;
            } else if (event.target.value > 20000) {
                GrantForm.revisionModel.technical.duration = 20000;
                this.isValidDuration = true;
            }
        },
        checkForValidDate() {
            let startDate = this.moment(this.startDate).format("YYYY-MM-DD");
            let endDate = this.moment(this.endDate).format("YYYY-MM-DD");

            if (startDate > endDate) {
                this.isValidStartDate = true;
            } else if (endDate < startDate) {
                this.isValidEndDate = true;
            } else {
                this.isValidStartDate = false;
            }
        },
        handleValidFounds() {
            if (
                GrantForm.revisionModel.technical.totalFundingRequested >= 1 &&
                GrantForm.revisionModel.technical.totalFundingRequested <= 20000
            ) {
                this.isValidFouds = false;
            } else {
                this.isValidFouds = true;
            }
        },
        setMinMaxFounds() {
            if (event.target.value < 1) {
                GrantForm.revisionModel.technical.totalFundingRequested = 1;
                this.isValidFouds = true;
            } else if (event.target.value > 20000) {
                GrantForm.revisionModel.technical.totalFundingRequested = 20000;
                this.isValidFouds = true;
            } else {
                this.isValidFouds = false;
            }
        }
    },
    watch: {
        startDate(newValue, oldValue) {
            GrantForm.revisionModel.technical.startDate = this.moment(
                newValue
            ).format("YYYY-MM-DD");
        },
        endDate(newValue, oldValue) {
            GrantForm.revisionModel.technical.endDate = this.moment(
                newValue
            ).format("YYYY-MM-DD");
        }
    }
};
</script>
<style lang="scss" scoped>
a {
    color: black;

    &:hover {
        text-decoration: underline;
    }
}

textarea.form-control,
.form-group textarea.el-input__inner,
.el-date-picker .el-input textarea.el-input__inner {
    border: 1px solid #2b3553;
    border-radius: 5px;
}
</style>
